import { FC } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { WhatsappCampaign } from '../../components/CreateCampaign_v2/WhatsappCampaign';
import { RouteConstants } from '@/features/router/RouteConstants';

export const CampaignsWhatsappEditFlowV2: FC = () => {
  const history = useHistory();
  const { campaignId } = useParams<{ campaignId: string }>();

  const handleExitToList = () => {
    history.push(RouteConstants.whatsappCampaigns);
  };

  return <WhatsappCampaign mode='edit' campaignId={campaignId} onExitToList={handleExitToList} />;
};
